import { gsap } from "gsap";
import scrollEvents from './scrollEvents';

const init = () => {

    const confTables = document.querySelectorAll('.configurator-card__table');

    if(confTables.length > 0) {

        const moveToActive = (confTableButton, item) => {

            if(item){
                confTableButton.style.top = item.offsetTop + 'px';
                confTableButton.style.height = item.offsetHeight + 'px';
            }else{
                confTableButton.style.opacity = 0;
            }
        };

        const checkCombination = () => {

            let combination = [];

            confTables.forEach(function (el) {

                let confTableItemActive = el.querySelector('tr.active');

                if(confTableItemActive){
                    combination.push(confTableItemActive.getAttribute('data-combination'));
                }
            });

            let combinationString = combination.join('');

            let tdTablesActive = document.querySelectorAll(`.table-data-row:not(.hidden)`);
            let tdTables = document.querySelectorAll(`.table-data-row--${combinationString}`);

            if(tdTables.length > 0){
                
                if(tdTablesActive.length > 0){
                    tdTablesActive.forEach( (tdTodeactive) => {
                        tdTodeactive.classList.add('hidden');
                    });
                }

                tdTables.forEach( (tdToActive) => {
                    tdToActive.classList.remove('hidden');
                });

                gsap.to('.table-data-container', {autoAlpha: 1, height: 'auto', duration: 0.2});

                if(confTables.length === combination.length){
                    scrollEvents.scrollTo('.table-data-container');
                }
            }else{
                gsap.to('.table-data-container', {autoAlpha: 0, height: 0, duration: 0.2});
            }
        };

        confTables.forEach(function (el) {

            const confTableItems = el.querySelectorAll('tr');
            let confTableItemActive = el.querySelector('tr.active');
            const confTableButton = el.querySelector('.configurator-card__button');
            
            moveToActive(confTableButton, confTableItemActive);

            confTableItems.forEach(function (item) {

                item.addEventListener('mouseenter', () => {

                    confTableButton.style.opacity = 1;

                    confTableButton.style.top = item.offsetTop + 'px';
                    confTableButton.style.height = item.offsetHeight + 'px';
                });

                item.addEventListener('mouseleave', () => {

                    moveToActive(confTableButton, confTableItemActive);
                });

                item.addEventListener('click', () => {
                    if(confTableItemActive){
                        confTableItemActive.classList.remove('active');
                    }
                    item.classList.add('active');

                    confTableItemActive = item;

                    checkCombination();
                });
            });
        });
    }
};

export default {init};